import store from '../../store';
import Contact from '@/services/contact-service';
import Message from '@/weon/models/Message';
import { EventBus } from '@/event-bus.js';

export default class StatusWhatsAppMessageEvent {
  constructor(body) {
    if (body.status != 'sent') {
      const styleLog =
        'color: #3949AB; font-weight: bold; background-color: #FFF59D;';
      console.group('%c StatusWhatsAppMessageEvent: ', styleLog);
      console.log(
        '%c [event]',
        'color: #F44336;',
        JSON.stringify(body, null, 4),
      );

      if (body.messageUniqueid == '') {
        if (body.status == 'INACTIVE_SESSION_NOT_OPTED_IN') {
          store.dispatch('showSnackbar', {
            text: 'O número de Whatsapp está desconectado',
            type: 'error',
          });
        } else if ((body.status = 'WHATSAPP_NOT_EXISTS')) {
          store.dispatch('showSnackbar', {
            text: 'O número de Whatsapp não existe',
            type: 'error',
          });
        }
      } else {
        store.dispatch('jobs/updateStatusMessage', body);
      }
    }
  }
}
